/**
 * Generated by yarn sync-org — do not edit by hand.
 * Active client resources include logo.svg.
 */
import type { SvgProps } from 'react-native-svg';
import ClientLogoSvg from '../../assets/images/brand/client-logo.svg';

export const HAS_CLIENT_LOGO = true as const;
export type ClientLogoProps = SvgProps;
export { ClientLogoSvg };
export default ClientLogoSvg;
